import React from "react";
import { RoleActivityContextProvider } from "./RoleActivityView";
import RoleActivity from "./views/RoleActivity";

const RoleActivityPage = () => {
  return (
    <div>
      <RoleActivityContextProvider>
        <RoleActivity />
      </RoleActivityContextProvider>
    </div>
  );
};

export default RoleActivityPage;
